// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__7XDDA","logo":"Footer_logo__KE-ZA","textcolor":"Footer_textcolor__ecXBL","social":"Footer_social__ao7tR"};